import { render, staticRenderFns } from "./AiFormatFixedPhraseSelector.vue?vue&type=template&id=e5f9b684&scoped=true&"
import script from "./AiFormatFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./AiFormatFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AiFormatFixedPhraseSelector.vue?vue&type=style&index=0&id=e5f9b684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f9b684",
  null
  
)

export default component.exports